import React from 'react';
import { Link } from 'react-router-dom';

function UnexpectedQuestionsGuide({ darkMode }) {
  const cardClass = darkMode 
    ? 'bg-gray-800 text-white' 
    : 'bg-white text-gray-800';

  return (
    <div className="min-h-screen py-8 px-4 bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="max-w-4xl mx-auto">
        {/* 헤더 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-red-600 to-orange-600 bg-clip-text text-transparent">
            돌발질문 & 압박면접 대처법
          </h1>
          <p className={`text-xl ${darkMode ? 'text-gray-300' : 'text-gray-600'} leading-relaxed`}>
            당황하지 말고 진정성 있게! 자연스러운 대응이 최고의 전략이에요 😰➡️😊
          </p>
        </div>

        {/* 돌발질문이 왜 나올까? */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🤔</span>
            면접관은 왜 돌발질문을 할까요?
          </h2>
          
          <p className="text-lg mb-6 leading-relaxed">
            준비된 답변도 중요하지만, 면접관이 정말 궁금한 건 <strong>"이 사람의 진짜 모습"</strong>이에요!
          </p>

          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'}`}>
              <h3 className="font-bold mb-3 text-blue-600">⚡ 순발력과 사고력 테스트</h3>
              <p className="text-sm leading-relaxed">
                갑작스러운 상황에서도 침착하게 대응할 수 있는지, 논리적으로 생각할 수 있는지 봅니다.
              </p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">🎭 진정성 파악</h3>
              <p className="text-sm leading-relaxed">
                암기한 답변이 아니라 진짜 본인의 생각과 가치관이 어떤지 알고 싶어합니다.
              </p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'}`}>
              <h3 className="font-bold mb-3 text-purple-600">💡 창의성과 문제해결 능력</h3>
              <p className="text-sm leading-relaxed">
                정답이 없는 질문에 어떻게 접근하는지, 창의적으로 생각할 수 있는지 확인합니다.
              </p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-orange-900 bg-opacity-30' : 'bg-orange-50'}`}>
              <h3 className="font-bold mb-3 text-orange-600">🔥 스트레스 상황 대응력</h3>
              <p className="text-sm leading-relaxed">
                실무에서도 예상 못한 일들이 많으니까, 그럴 때 어떻게 반응하는지 보려는 것입니다.
              </p>
            </div>
          </div>
        </div>

        {/* 황금 대응 전략 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">✨</span>
            진정성 있는 황금 대응 전략
          </h2>
          
          <div className={`p-6 rounded-xl ${darkMode ? 'bg-yellow-900 bg-opacity-30' : 'bg-yellow-50'} border-l-4 border-yellow-500 mb-6`}>
            <h3 className="text-lg font-bold mb-3 text-yellow-600">🎯 핵심 원리</h3>
            <p className="leading-relaxed">
              완벽한 답변보다는 <strong>"솔직하고 자연스러운 답변"</strong>이 훨씬 좋은 인상을 줍니다! 
              평소 생각해보지 않았다고 솔직히 말하는 것도 진정성의 표현이거든요.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className={`p-6 rounded-xl border-l-4 border-blue-500 ${darkMode ? 'bg-blue-900 bg-opacity-20' : 'bg-blue-50'}`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</div>
                <span className="font-bold text-blue-600">솔직한 인정 (5초)</span>
              </div>
              <p className="text-sm mb-2">"평소 생각해보지 않았지만..."</p>
              <p className="text-xs">진정성 있게 자연스러운 모습 보여주기</p>
            </div>

            <div className={`p-6 rounded-xl border-l-4 border-green-500 ${darkMode ? 'bg-green-900 bg-opacity-20' : 'bg-green-50'}`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</div>
                <span className="font-bold text-green-600">논리적 설명 (30초)</span>
              </div>
              <p className="text-sm mb-2">내 생각과 그 이유를 차근차근</p>
              <p className="text-xs">왜 그렇게 생각하는지 논리적으로 설명</p>
            </div>

            <div className={`p-6 rounded-xl border-l-4 border-purple-500 ${darkMode ? 'bg-purple-900 bg-opacity-20' : 'bg-purple-50'}`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</div>
                <span className="font-bold text-purple-600">자연스러운 연결 (5초)</span>
              </div>
              <p className="text-sm mb-2">가능하면 업무나 회사와 연결</p>
              <p className="text-xs">억지스럽지 않게 자연스럽게 마무리</p>
            </div>
          </div>
        </div>

        {/* 돌발질문 실전 예시 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🎪</span>
            돌발질문 실전 예시 & 답변 (총 40초)
          </h2>
          
          {/* 동물 질문 */}
          <div className="mb-8">
            <h3 className="text-xl font-bold mb-4 text-center">🐜 동물 질문</h3>
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} border-l-4 border-green-500`}>
              <div className="space-y-4">
                <div>
                  <span className="font-bold text-green-600">[질문]</span>
                  <p className="mt-1">"만약 동물이 된다면 무엇이 되고 싶나요?"</p>
                </div>
                <div>
                  <span className="font-bold text-blue-600">[솔직한 답변]</span>
                  <p className="mt-1 font-semibold">
                    "제가 평소 깊이 생각해보지는 않았지만, 좋아하는 동물은 개미입니다. 
                    개미는 작지만 팀워크가 정말 뛰어납니다. 각자 맡은 역할을 확실히 하면서도 
                    공동의 목표를 위해 협력하는 모습이 인상적이고, 자신보다 몇 배 무거운 것도 들 수 있는 
                    끈기와 성실함도 본받고 싶습니다. 이런 모습이 회사에서도 필요한 자질이라고 생각합니다."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 무인도 질문 */}
          <div className="mb-8">
            <h3 className="text-xl font-bold mb-4 text-center">🏝️ 무인도 질문</h3>
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} border-l-4 border-blue-500`}>
              <div className="space-y-4">
                <div>
                  <span className="font-bold text-blue-600">[질문]</span>
                  <p className="mt-1">"무인도에 한 가지만 가져갈 수 있다면 무엇을 가져가겠어요?"</p>
                </div>
                <div>
                  <span className="font-bold text-purple-600">[솔직한 답변]</span>
                  <p className="mt-1 font-semibold">
                    "구체적으로 계획해본 적은 없지만, 아마 책을 가져갈 것 같습니다. 
                    무인도에서는 할 일이 많지 않을 텐데, 책이 있으면 지루하지도 않고 
                    계속 배울 수 있을 것 같습니다. 특히 실용적인 책이면 생존에도 도움이 될 수 있고, 
                    평소에도 새로운 것을 배우는 걸 좋아해서 그런 것 같습니다."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 1억원 질문 */}
          <div className="mb-6">
            <h3 className="text-xl font-bold mb-4 text-center">💰 돈 질문</h3>
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} border-l-4 border-orange-500`}>
              <div className="space-y-4">
                <div>
                  <span className="font-bold text-orange-600">[질문]</span>
                  <p className="mt-1">"갑자기 1억원이 생긴다면 어떻게 쓰시겠어요?"</p>
                </div>
                <div>
                  <span className="font-bold text-red-600">[솔직한 답변]</span>
                  <p className="mt-1 font-semibold">
                    "와, 1억원이라니! 진짜 꿈같은 일이네요. 구체적으로 계획해본 적은 없지만, 
                    먼저 부모님께 효도를 하고 싶습니다. 그동안 고생 많이 하셨거든요. 
                    그리고 일부는 자기계발에 투자하고 싶고, 새로운 기술을 배우거나 
                    자격증 취득 같은 걸로요. 나머지는 저축해서 미래를 준비하고 싶습니다."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 압박면접 대응법 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">😤</span>
            압박면접 똑똑한 대응법
          </h2>
          
          <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'} border-l-4 border-red-500 mb-6`}>
            <h3 className="text-lg font-bold mb-3 text-red-600">🔥 압박면접의 진짜 의도</h3>
            <p className="leading-relaxed">
              면접관이 여러분을 괴롭히려는 게 아닙니다! 스트레스 상황에서도 <strong>논리적이고 침착하게</strong> 
              대응할 수 있는지 보려는 것입니다. 감정적으로 반응하지 말고 <strong>두괄식으로 차근차근</strong> 답변하면 됩니다.
            </p>
          </div>

          {/* 압박면접 예시 1 */}
          <div className="mb-8">
            <h3 className="text-xl font-bold mb-4 text-center">💪 특별함 어필 질문</h3>
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} border-l-4 border-purple-500`}>
              <div className="space-y-4">
                <div>
                  <span className="font-bold text-purple-600">[압박질문]</span>
                  <p className="mt-1">"다른 지원자들보다 뭐가 특별한가요?"</p>
                </div>
                <div>
                  <span className="font-bold text-green-600">[두괄식 답변]</span>
                  <p className="mt-1 font-semibold">
                    "네, 다른 지원자들도 좋으신 분들이 많겠지만, 제가 다른 지원자보다 특별한 것은 
                    이 회사의 핵심가치인 '고객 중심'이 저와 완전히 부합한다는 점입니다. 
                    저는 아르바이트할 때부터 고객 만족을 최우선으로 생각해왔고, 
                    실제로 고객 재방문율 향상에도 기여한 경험이 있어서 
                    이 회사에서 그 경험을 잘 활용할 수 있을 것 같습니다."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 압박면접 예시 2 */}
          <div className="mb-8">
            <h3 className="text-xl font-bold mb-4 text-center">⏰ 취업 준비 기간 질문</h3>
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} border-l-4 border-blue-500`}>
              <div className="space-y-4">
                <div>
                  <span className="font-bold text-blue-600">[압박질문]</span>
                  <p className="mt-1">"왜 이렇게 오래 취업 준비를 하고 있나요?"</p>
                </div>
                <div>
                  <span className="font-bold text-orange-600">[두괄식 답변]</span>
                  <p className="mt-1 font-semibold">
                    "시간이 오래 걸린 건 사실이지만, 저에게 정말 맞는 회사를 신중하게 찾고 있었기 때문입니다. 
                    그 과정에서 여러 경험도 쌓고 부족한 부분도 보완했습니다. 
                    특히 이 회사에 지원하기 위해 관련 자격증도 취득했고, 
                    프로젝트 경험도 더 쌓았거든요. 오히려 더 준비된 상태로 지원할 수 있게 되었다고 생각합니다."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 압박면접 예시 3 */}
          <div className="mb-6">
            <h3 className="text-xl font-bold mb-4 text-center">🤔 능력 의심 질문</h3>
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} border-l-4 border-green-500`}>
              <div className="space-y-4">
                <div>
                  <span className="font-bold text-green-600">[압박질문]</span>
                  <p className="mt-1">"이 정도 실력으로 우리 회사에 도움이 될까요?"</p>
                </div>
                <div>
                  <span className="font-bold text-red-600">[두괄식 답변]</span>
                  <p className="mt-1 font-semibold">
                    "아직 부족한 부분이 많다는 건 인정합니다. 하지만 제가 이 회사에 도움이 될 수 있는 이유는 
                    빠른 학습능력과 성실함이라고 생각합니다. 
                    대학교 때도 새로운 프로젝트를 할 때마다 모르는 기술이 많았지만, 
                    끝까지 포기하지 않고 배워서 성공적으로 완성했거든요. 
                    회사에서도 열심히 배우고 노력해서 꼭 필요한 사람이 되겠습니다."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 대응 전략 핵심 포인트 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🎯</span>
            대응 전략 핵심 포인트
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">✅ 이렇게 하세요!</h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <strong>솔직하게 인정하기</strong>
                  <p className="text-xs mt-1">"평소 생각해보지 않았지만...", "확실히 그런 부분이 있네요..."</p>
                </li>
                <li>
                  <strong>감정적이지 않게 차분히</strong>
                  <p className="text-xs mt-1">화내거나 당황하지 말고 침착하게 논리적으로 답변</p>
                </li>
                <li>
                  <strong>두괄식으로 명확하게</strong>
                  <p className="text-xs mt-1">질문에 정확히 답변하고 그 이유를 설명</p>
                </li>
                <li>
                  <strong>긍정적으로 전환하기</strong>
                  <p className="text-xs mt-1">약점도 발전 가능성이나 노력 의지로 연결</p>
                </li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'}`}>
              <h3 className="font-bold mb-3 text-red-600">❌ 절대 하지 마세요!</h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <strong>면접관 질문 평가하기</strong>
                  <p className="text-xs mt-1">"좋은 질문이네요", "흥미로운 질문이군요" 같은 멘트</p>
                </li>
                <li>
                  <strong>감정적으로 반응하기</strong>
                  <p className="text-xs mt-1">화내거나 짜증내거나 방어적으로 대응</p>
                </li>
                <li>
                  <strong>너무 오래 침묵하기</strong>
                  <p className="text-xs mt-1">10초 이상 말 없이 있으면 어색해져요</p>
                </li>
                <li>
                  <strong>포기하는 태도</strong>
                  <p className="text-xs mt-1">"모르겠습니다", "그런 질문은 왜 하시나요?" 같은 반응</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 실전 연습법 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🏋️</span>
            실전 연습법
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'}`}>
              <h3 className="font-bold mb-3 text-blue-600">🎲 랜덤 질문 연습</h3>
              <p className="text-sm leading-relaxed mb-3">
                친구나 가족에게 예상 못한 질문을 부탁해보세요. "만약에..." 질문들을 즉석에서 만들어 물어보라고 하세요.
              </p>
              <ul className="text-xs space-y-1">
                <li>• 하루에 3개씩 다른 질문</li>
                <li>• 40초 안에 답변 연습</li>
                <li>• 녹음해서 자연스러운지 확인</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">📰 뉴스 즉석 요약</h3>
              <p className="text-sm leading-relaxed mb-3">
                뉴스나 책을 보고 갑자기 "이거 어떻게 생각해?" 라고 물어보는 연습을 해보세요. 논리적 사고 능력이 늘어납니다.
              </p>
              <ul className="text-xs space-y-1">
                <li>• 30초 안에 의견 정리</li>
                <li>• 찬성/반대 이유 설명</li>
                <li>• 다른 관점도 고려해보기</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'}`}>
              <h3 className="font-bold mb-3 text-purple-600">🎭 압박 상황 연습</h3>
              <p className="text-sm leading-relaxed mb-3">
                일부러 조금 도전적인 질문을 받아보세요. "왜?", "정말?"같은 추가 질문에도 당황하지 않는 연습이 중요합니다.
              </p>
              <ul className="text-xs space-y-1">
                <li>• 감정 조절 연습</li>
                <li>• 차분한 목소리 톤 유지</li>
                <li>• 긍정적 마인드셋 훈련</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 뒤로가기 */}
        <div className="text-center">
          <Link 
            to="/guide-success" 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          >
            <span className="mr-2">←</span>
            면접성공가이드로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  );
}

export default UnexpectedQuestionsGuide;